const price = ((tableType, data) => {
  let toppingPrice = 0;
  data?.activeTopping?.forEach((topping) => toppingPrice += topping.itemPrice || 0);
  
  // Price field mapping
  const priceFieldMap = {
    "AC": "priceForAC",
    "Non AC": "priceForNonAC",
    "Garden": "priceForGarden",
    "Banquet Hall": "priceForBanquetHall",
    "Hut": "priceForHut",
    "Online": "priceForOnline",
    "Room Service": "priceForRoomService",
    "HD": "priceForHD",
    "Parcel": "priceForParcel",
  };
  
  const priceField = priceFieldMap[tableType];
  const basePrice = priceField ? (data[priceField] || data.itemPrice) : data.itemPrice;
  
  return basePrice + toppingPrice;
});

export default price;